module.exports = __webpack_public_path__ + "static/media/listIconPoi1.2e757d24.svg";